import './index.scss'
import Bridge from 'src/frontend-lib/lib/Bridge'

const template = `<span>
  为保证视频正常播放，请升级到APP最新版本。去升级>>>
</span>`

import { versionfunegt } from 'src/frontend-lib/tools/utils'

import { getPlatform } from 'src/frontend-lib/tools/getPlatform'

const init = () => {
  const platform = getPlatform()

  if (
    platform.isYixinliApp &&
    !versionfunegt(platform.yixinliAPPVersion, '8.3.10')
  ) {
    const el = document.createElement('div')
    el.setAttribute('class', 'fixed-top-upgrade-app-verson-app')
    el.innerHTML = template
    const beforeElement = document.querySelector('#top-wrapper .video-name')
    beforeElement.parentElement.insertBefore(el, beforeElement)

    el.addEventListener('click', () => {
      const bridge = new Bridge()
      if (platform.isAndroid) {
        bridge.call('showMessage', {
          content: '请前往应用市场更新'
        })
      } else {
        bridge.call('doUpgrade')
      }
    })
  }
}

export default init



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/upgradeAppVersionTips/index.js